// extracted by mini-css-extract-plugin
module.exports = {"breakdownSpacer":"_1DZxvgljVudn186ajmFGUw=="};